import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "География. 7 класс",
        subject: "Методические особенности проведения практической работы по теме «Литосфера и рельеф Земли»",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Методические особенности проведения практической работы по теме «Литосфера и рельеф Земли»",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Барабанов Вадим Владимирович",
                grade: "научный сотрудник лаборатории социально-гуманитарного общего образования ФГБНУ «ИСРО»",
                subGrade: "",
                imageSrc: "./images/author1.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<p style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem;'>В данном кейсе освещаются методические подходы к формированию следующих умений: «называть особенности географических процессов на границах литосферных плит с учётом характера взаимодействия и типа земной коры» и «устанавливать (используя географические карты) взаимосвязи между движением литосферных плит и размещением крупных форм рельефа» в контексте практических работ.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Учитель получит рекомендации по организации и проведению новых практических работ «Анализ физической карты и карты строения земной коры с целью выявления закономерностей распространения крупных форм рельефа» и «Объяснение вулканических или сейсмических событий, о которых говорится в тексте». </p>"
                        }
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: `<p>Познакомимся с рекомендациями по организации образовательного процесса по теме «Литосфера и рельеф Земли» при работе по новой Федеральной рабочей программе. Содержание темы «Литосфера и рельеф Земли» включает две новые практические работы: «Анализ физической карты и карты строения земной коры с целью выявления закономерностей распространения крупных форм рельефа» и «Объяснение вулканических или сейсмических событий, о которых говорится в тексте».</p>
                        <p>Рубрика «Планируемые предметные результаты» предусматривает формирование умений «называть особенности географических процессов на границах литосферных плит с учётом характера взаимодействия и типа земной коры» и «устанавливать, используя географические карты, взаимосвязи между движением литосферных плит и размещением крупных форм рельефа». Обучающиеся получат возможность:</p>
                        <p>
                            <ul>
                                <li>Различать материковую и океаническую земную кору;</li>
                                <li>Показывать на карте и обозначать на контурной карте крупные формы рельефа Земли; </li>
                                <li>Называть причины землетрясений и вулканических извержений.</li>
                            </ul>
                        </p>
                        <p>Первый урок по теме рекомендуется посвятить повторению этого изучавшегося давно материала. При повторении рекомендуется использовать знакомую обучающимся  схему «Круговорот горных пород» — её можно скачать в разделе «Дополнительный блок». 
Можете использовать следующий шаблон для рассказа:
</p>
                        <p>«Земная кора состоит из относительно целостных блоков — литосферных плит. Они находятся в постоянном движении относительно друг друга. Крупнейшими (планетарными) формами рельефа на Земле являются материки и впадины океанов, образовавшиеся под воздействием внутренних сил Земли.</p> 
                        <p>Выступы материков соответствуют материковой земной коре.</p>
                        <p>В областях распространения океанической коры лежат впадины, которые наполнены водой океанов.</p>
                        <p>Материковая кора отличается от океанической по толщине и строению. Толщина материковой коры в среднем 30—40 км, а под горами достигает 70 км, океаническая кора гораздо тоньше — 3-7 км.</p>
                        <p>В материковой коре выделяют три слоя:  верхний — осадочный, средний — «гранитный» и нижний — «базальтовый». Океаническая кора имеет только два слоя — осадочный и «базальтовый». На дне океанов и на суше выделяют две основные крупные формы рельефа — горы и равнины».</p>
                        <p>При ответе на вопросы ученикам можно предложить использовать рисунок «Типы земной коры».</p>
                        <p>Планируемый предметный результат «называть особенности географических процессов на границах литосферных плит с учётом характера взаимодействия и типа земной коры» относится к числу предметных результатов, осваиваемых на уровне «знание и понимание». 
                        </p>
                        <p>Возможны два разных варианта достижения этого результата. </p>
                        <p>Первый вариант предполагает самостоятельную работу обучающихся с текстом учебника и картой атласа «Строение земной коры». </p>
                        <p>Школьникам нужно прочитать соответствующий фрагмент параграфа с целью найти ответы на заранее предложенные учителем вопросы.</p>
                        <p>Можно предложить обучающимся следующие вопросы:</p>
                        <p>
                            <ol>
                                <li>Найдите на карте крупные литосферные плиты и перечислите их.</li>
                                <li>Какие два типа границ между литосферными плитами можно выделить?</li>
                                <li>Какие процессы происходят в районах столкновения литосферных плит?</li>
                                <li>Приведите примеры крупных форм рельефа (горные системы, островные дуги), образовавшихся в районах границ литосферных плит разного типа. </li>
                            </ol>
                        </p>
                        <p>Второй вариант предполагает (если вы пока работаете по одному из старых учебников) объяснение материала. Но для начала обучающимся нужно дать ответы на вопросы и задания на карте: </p>
                        <p>
                            <ol>
                                <li>Найдите на карте крупные литосферные плиты и перечислите их.</li>
                                <li>Какие два типа границ между литосферными плитами можно выделить?</li>
                            </ol>
                        </p>`
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Статья «Земля уходит из-под ног: тектоника литосферных плит» // Журнал «ПостНаука». URL. https://postnauka.org/longreads/88792  (дата обращения 06.06.2023)",
                "Учебник по курсу «Общая геология»: тектоника литосферных плит // Образовательный геологический сайт Юрия Попова. URL. https://popovgeo.sfedu.ru/lecture_19 (дата обращения 06.06.2023) ",
            ],
            sites: [
                ""
            ],
            filesToDownload: [
                {
                    link: "./files/additional.pdf",
                    fileName: "Задания по теме методические особенности проведения практической работы по теме «Литосфера и рельеф Земли»"
                }
            ]
        }
    ],
};
